import React from "react";

const items = [
  "LEARN TODAY",
  "LEAD TOMORROW",
  "SHAPE YOUR FUTURE",
  "DREAM",
  "LEARN",
  "ACHIEVE",
  "INVEST IN YOURSELF",
];

export default function Marquee() {
  const track = [...items, ...items];
  return (
    <div className="relative overflow-hidden bg-[#0A1740] py-4">
      <div className="flex whitespace-nowrap marquee-track gap-14">
        {track.map((t, i) => (
          <div key={i} className="flex items-center gap-14">
            <span className="text-2xl md:text-3xl font-black gold-gradient section-title">{t}</span>
            <span className="w-2 h-2 rounded-full bg-[#FBBF24]" />
          </div>
        ))}
      </div>
    </div>
  );
}
